document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    var purchaseBtnQuick = document.querySelector('[data-purchase-btn-quick]');
    var selectElement = document.querySelector('[data-productlineitemoption]');
    var selectElementPump = document.querySelector('[data-productlineitemoption--pump]');
    var selectPumpElement = document.querySelector('[data-pumpProperties]');
    purchaseBtnQuick.addEventListener('click', function (event) {
      if (selectElement) {
        if (selectElement.value === '*') {
          alert('オプションから1つ選択してください');
          event.preventDefault();
        } else {
          purchaseButtonQuick();
        }
      }
      if (selectElementPump) {
        if (selectElementPump.value === '*') {
          alert('オプションから1つ選択してください');
          event.preventDefault();
        } else {
          purchaseButtonQuick();
        }
      }
      if (selectPumpElement) {
        if (selectPumpElement.value === '*') {
          alert('オプションから1つ選択してください');
          event.preventDefault();
        } else {
          purchaseButtonQuick();
        }
      }
      function purchaseButtonQuick() {
        var variantId = document.querySelector('.formVariantId').value;
        var quantity = 1;
        var postcard = document.querySelector('[data-postcard]')?.value || null;
        var engravedText = document.querySelector('[data-engravedtext]')?.value || null;
        var pumpPropertiesList = document.querySelector('[data-pumppropertieslist]')?.value || null;
        var properties = {};
        if (postcard) properties["Message Card"] = postcard;
        if (engravedText) properties["Engraved Text"] = engravedText;
        if (pumpPropertiesList) properties["Pump Properties List"] = pumpPropertiesList;
        var formData = {
          'items': [{
            'id': variantId,
            'quantity': quantity,
            'properties': Object.keys(properties).length > 0 ? properties : undefined
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then(response => {
            if (response.ok) {
              window.location.href = '/checkout';
            } else {
              alert('Could not add product to cart. Please try again.');
            }
          })
          .catch(error => {
            console.error('Error adding product to cart', error);
          });
      }
    });
  }, 5000);
});